require('./cardCancelDeferPurchaseStep1.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @components
const CardMovementInstallmentChart = require('components/cards/cardMovementInstallmentChart/cardMovementInstallmentChart');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('components/commons/OKModal/OKModal');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

class cardCancelDeferPurchaseStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isInstallmentModalOpen: false
        };

        this.handleToggleInstallmentModal = this.handleToggleInstallmentModal.bind(this);
    }

    handleToggleInstallmentModal() {
        this.setState({
            isInstallmentModalOpen: !this.state.isInstallmentModalOpen
        });
    }

    render() {
        const {
            immCardMovementInstallmentsChart,
            informativeList
        } = this.props;

        const contentModal = (
            <CardMovementInstallmentChart immInstallments={immCardMovementInstallmentsChart.getIn(['installmentData', 'installmentList'])} />
        );

        return (
            <div className="card-cancel-defer-purchase-step1">
                <div className="card-cancel-defer-purchase-step1__title">
                    <FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_title" />
                </div>
                <div className="card-cancel-defer-purchase-step1__subtitle">
                    <FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_subtitle" />
                </div>
                {informativeList}
                <div className="card-cancel-defer-purchase-step1__link">
                    <OKLink
                        modifier="emphasize"
                        onClick={this.handleToggleInstallmentModal}
                        loading={immCardMovementInstallmentsChart.get('isFetching')}
                        disabled={immCardMovementInstallmentsChart.get('error')}
                    >
                        <FormattedText
                            value="cardCancelDeferPurchase-cardCancelDeferPurchase_amortizationLink"
                            format="uppercase"
                        />
                    </OKLink>
                </div>
                <OKModal
                    content={contentModal}
                    isOpen={this.state.isInstallmentModalOpen}
                    onCloseCallback={this.handleToggleInstallmentModal}
                    size="large"
                    title="cardPaymentPurchaseDeferralTable-title"
                />
            </div>
        );
    }
}

cardCancelDeferPurchaseStep1.propTypes = {
    getCancelDeferPurchaseInfo: PropTypes.func.isRequired,
    immCardCancelDeferPurchase: PropTypes.object.isRequired,
    immCardMovementInstallmentsChart: PropTypes.object,
    informativeList: PropTypes.any,
    onHandleToggleInstallmentModal: PropTypes.func,
};

module.exports = cardCancelDeferPurchaseStep1;
